import { IUserState } from '~api/RampPgApiSdk';
import { OnUserRegisteredBehavior } from '~constants/Journeys';
import { UserIdType } from '~domain/entities/Config';
import { ConfigRepository } from '~repositories/ConfigRepository';
import { UserRepository } from '~repositories/UserRepository';
import { diContainer } from '~setup/diContainer';
import serviceNames from '~setup/RampService';

import { TriageAlertDisplayedUseCase } from './in-store/TriageAlertDisplayedUseCase';
import { RedirectedToSignInPageUseCase } from './RedirectedToSignInPageUseCase';

export class UserAlreadyRegisteredUseCase {
    private userRepository: UserRepository;
    private configRepository: ConfigRepository;
    private users: IUserState[];

    constructor(users: IUserState[]) {
        this.userRepository = diContainer.get(serviceNames.userRepository);
        this.configRepository = diContainer.get(serviceNames.configRepository);
        this.users = users;
    }

    execute() {
        if (!this.users.length) {
            return;
        }

        const {
            journey: { onUserRegisteredBehavior = OnUserRegisteredBehavior.DEFAULT }
        } = this.configRepository;
        const { setMatchedExistingUsers } = this.userRepository;

        setMatchedExistingUsers(this.users);

        if (onUserRegisteredBehavior === OnUserRegisteredBehavior.DEFAULT) {
            new RedirectedToSignInPageUseCase().execute();
        }

        if (onUserRegisteredBehavior === OnUserRegisteredBehavior.IN_STORE) {
            this.highlightFields();
            new TriageAlertDisplayedUseCase().execute();
        }
    }

    private highlightFields = () => {
        const {
            userFormStore: { values }
        } = this.userRepository;
        const {
            resetHighlightedFields,
            setHighlightedField,
            iamConfig: { identifiers }
        } = this.configRepository;
        resetHighlightedFields();
        identifiers.forEach((identifier) => {
            if (values[identifier] && this.isIdentifierRegistered(identifier)) {
                setHighlightedField(identifier);
            }
        });
    };

    private isIdentifierRegistered = (identifier: UserIdType) => {
        // records in "users" indicate that identifier is either registered or conflicted
        return this.users.some((user) => user.userIdType === identifier);
    };
}
